import { problems } from '@/mocks/homeData';

export default function ProblemSection() {
  return (
    <section id="problem" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Kurban dönemi ve canlı hayvan ticareti karmaşık olmak zorunda değil.
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            Geleneksel yöntemlerle operasyon yönetmek hem zaman kaybına hem de maddi hatalara yol açar.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {problems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 group"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-primary-50 rounded-lg mb-5 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2.5">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}